import { render } from "./UniqueKeyMessageResultPage.vue?vue&type=template&id=fb4db6da&scoped=true"
import script from "./UniqueKeyMessageResultPage.vue?vue&type=script&lang=js"
export * from "./UniqueKeyMessageResultPage.vue?vue&type=script&lang=js"

import "./UniqueKeyMessageResultPage.vue?vue&type=style&index=0&id=fb4db6da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4db6da"]])

export default __exports__